import * as _ from 'lodash-es';

interface NormalizedTranslationArgs<T> {
    0: T;
}

/**
 * Allows to pass a primitive (not an object) substitution argument in translation.
 * In this case the argument can be accessed in the translation as "{{0}}".
 *
 * @example
 * Locale string: "Cancel {{0}} Orders"
 * Usage: translationService.translate(stringId, normalizeTranslationArgs(5));
 *
 * @param {*} args
 */
export const normalizeTranslationArgs = <T>(args: T): T | NormalizedTranslationArgs<T> => {
    const isPrimitiveToNormalize = args !== undefined
        && !_.isObjectLike(args);

    return isPrimitiveToNormalize
        ? {0: args}
        : args;
};
